// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/checkout-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/checkout-banner-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkout_checkout__0l1eZ {
    display: flex;
    flex-direction: row;
    overflow-wrap: none;
    width: 94%;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: center;
}
.Checkout_leftSection__zfneh {
    margin-top: 1em;
    color: #000;
    background-color: transparent;
    width: 620px;
}

.Checkout_planBox__Ue\\+Kz {
    border-radius: 32px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.Checkout_semaBorder__ijxBV {
    border: 1px solid #69bf4a;
}
.Checkout_tirzBorder__pbDbJ {
    border: 1px solid #21cec9;
}
.Checkout_semaSides__jvKn0 {
    border-left: 10px solid #69bf4a;
    border-right: 10px solid #69bf4a;
}
.Checkout_tirzSides__OdVn\\+ {
    border-left: 10px solid #21cec9;
    border-right: 10px solid #21cec9;
}
.Checkout_semaBackground__KQh-d {
    background-color: #69bf4a;
}
.Checkout_tirzBackground__3Spx0 {
    background-color: #21cec9;
}
/* .semaImg {
    border-bottom: 10px solid #69bf4a;
    border-right: 10px solid #69bf4a;
}
.tirzImg {
    border-bottom: 10px solid #21cec9;
    border-right: 10px solid #21cec9;
} */

.Checkout_title__PIroP {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1em;
    border-top-left-radius: 2em;
    border-top-right-radius: 2em;
    width: 100%;
}
.Checkout_titleImage__bf1\\+M {    
    height: 150px;
    padding: 30px 60px;
    background-color: white;
    margin-left: 0.5em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    border-top-left-radius: 2em;
    border-bottom-right-radius: 2em;
}
.Checkout_titleName__V7zMV {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    line-height: 1.1;
}
.Checkout_titlePlan__11n5k {
    /* border-top-right-radius: 1em; */
    font-family: 'Aktive Grotesk', sans-serif;
    font-size: 40px;
    font-weight: 800;
    color: #fff;
    /* padding: 15px 30px; */
    padding: 0.25em 0;
    /* margin-right: 1em; */
    text-align: center;
}
.Checkout_titlePlan__11n5k p {
    margin: 0;
    font-size: 32px;
    font-weight: 500;
}
.Checkout_titleDose__Pvb9f {
    margin-top: 0.25em;
    margin-bottom: 0.25em;
    /* margin-left: 1em; */
    font-size: 24px;
    font-weight: 700;
    color: white;
    width: 100%;
    text-align: center;
}
.Checkout_planContainer__\\+DRrS {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding: 10px 60px;
}
.Checkout_planPrice__gyrRJ {
    width: 48%;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Cocon Bold', sans-serif;
    font-weight: 800;
    font-size: 48px;
}
.Checkout_planPeriod__rxG9e {
    font-size: 20px;
    font-weight: 500;
    font-family: 'Aktiv Grotesk';
    text-align: center;
}
.Checkout_planShipping__\\+O0KF {
    width: 48%;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Aktive Grotesk', sans-serif;
    font-weight: 800;
    font-size: 30px;
}
.Checkout_planFree__XEuoc {
    font-size: 36px;
    color: #69bf4a;
}
.Checkout_planSubtext__lUdql {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 0.5em;
    padding-bottom: 0.5em;
    padding-left: 0.5em;
    padding-right: 0.5em;
    font-size: 28px;
    color: gray;
    font-weight: 700;
}
.Checkout_differentArrow__27GL5 {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
}
.Checkout_selectButton__Zz46K {
    margin-top: 1em;
    position: relative;
}
.Checkout_selectButton__Zz46K select {
    width: 100%;
    padding: 10px;
    font-weight: bold;
    height: 64px;
    font-size: 30px;
    border-radius: 46px;
    text-align: center;
    border: 2px solid;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: none;
}
.Checkout_headerRule__KJJty {
    height: 10px;
    width: 90%;
    margin-left: 90px;
    margin-right: 90px;
    background-color: #69bf4a;
    position: absolute;
    bottom: -5px;
    border-radius: 999px;
}
.Checkout_horizontalRule__n93pZ {
    display: block;
    width: 90%;
    padding-left: 5%;
    height: 5px;
}
.Checkout_fieldRule__DFIVv {
    width: 100%;
    height: 5px;
}
.Checkout_verticalRule__Vl1fB {
    height: 50px;
    width: 5px;
}
.Checkout_fieldSection__eJ7V4 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.Checkout_cardTitle__BiVVj {
    margin-top: 0.5em;
    font-size: 32px;
    font-weight: 800;
}
.Checkout_field__4kVlV {
    margin: 1em 2em;
    font-size: 26px;
    font-weight: 700;
    border: 0;
    color: black;
    text-align: center;
    font-family: 'Aktive Grotesk', sans-serif;
}
.Checkout_field__4kVlV::placeholder {
    text-align: center;
}


.Checkout_emailContainer__kqdiD {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 26px;
    font-weight: 700;
    margin: 0.5em;
    align-items: center;
    width: 96%;
    border: 8px solid #69bf4a;
    border-radius: 2em;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.Checkout_emailContainer__kqdiD div {
    margin: 1em 0;
    padding-left: 2em;
    width: 40%;
    box-sizing: border-box;
    font-size: 26px;
    font-weight: 700;
    border: 0;
    color: grey;
}
.Checkout_emailContainer__kqdiD input {
    width: 60%;
    box-sizing: border-box;
    font-size: 26px;
    font-weight: 700;
    border: 0;
    color: black;
    border-top-right-radius: 2em;
    border-bottom-right-radius: 2em;
}
.Checkout_emailContainer__kqdiD input::placeholder {
    text-align: center;
}



.Checkout_phoneContainer__1ptV6 {
    width: 96%;
    border: 8px solid #69bf4a;
    border-radius: 2em;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 26px;
    font-weight: 700;
    margin: 0.5em;
}
.Checkout_phoneContainer__1ptV6 div {
    margin: 1em 0;
    padding-left: 2em;
    width: 35%;
    box-sizing: border-box;
    font-size: 26px;
    font-weight: 700;
    border: 0;
    color: grey;
}
.Checkout_phoneContainer__1ptV6 span {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 65%;
}
.Checkout_phonePart__-kgJP {
    color: black;
    width: 30%;
    font-size: 26px;
    font-weight: 700;
    border: 0;
    border-top-right-radius: 2em;
    border-bottom-right-radius: 2em;
}
.Checkout_phonePart__-kgJP::placeholder {
    text-align: center;
}
.Checkout_optInSection__hP38j {
    display: flex;
    align-items: flex-start;
    margin: 1em 2em;
}
.Checkout_optInSection__hP38j input {
    transform: scale(1.5);
}
.Checkout_optInLabel__PjAoJ {
    color: gray;
    font-size: 16px;
    padding-left: 1em;
}

.Checkout_cardBox__qnylL {
    width: 96%;
    border: 8px solid #69bf4a;
    border-radius: 2em;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 26px;
    font-weight: 700;
    margin: 0.5em;
}
.Checkout_billingAddress__6gDGd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.Checkout_city__rXsCS {
    width: 40%;
    margin: 1em 2em;
    font-family: 'Aktive Grotesk', sans-serif;
    font-size: 26px;
    font-weight: 700;
    border: 0;
    text-align: center;
    color: black;
}
.Checkout_stateFieldPlaceholder__2bVEc {
    text-align: center;
    color: grey;
}
.Checkout_stateField__Gaxa- {
    text-align: center;
    color: black;
}
.Checkout_statePopup__IpCml {
    position: fixed;
    top: 0%;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    border: 1px solid #ccc;
    z-index: 999;
    text-align: center;
    color: black;
}
.Checkout_stateOption__Ap2Y\\+:hover, .Checkout_stateOption__Ap2Y\\+:active, .Checkout_stateOption__Ap2Y\\+:focus {
    background-color: #69bf4a;
    color: white;
    font-weight: bold;
}

.Checkout_free__V-HB7 {
    color: #69bf4a;
    font-family: 'Cocon Bold', sans-serif;
    font-size: 32px;
}

.Checkout_rightSection__tXaO\\+ {
    width: 45%;
    font-family: 'Aktive Grotesk', sans-serif;
}

.Checkout_paymentDetails__Mt-Li h3 {
    font-size: 40px;
    font-weight: 800;
    margin: 0px 20px;
    text-align: center;
}

.Checkout_secureDetails__n3iFU {
    margin-top: 0.5em;
    text-align: center;
    font-size: 36px;
    font-weight: 800;
}

.Checkout_securePayment__V5ut3 {
    display: flex;
    justify-content: center;
    align-items: baseline;
    gap: 11px;
}

.Checkout_securePayment__V5ut3 p {
    color: #69bf4a;
    font-size: 20px;
    font-weight: 600;
}


.Checkout_subscribeButtonBox__ZCFvg {
    display: flex;
    justify-content: center;
    width: 100%;
    text-align: center;
    margin-top: 2em;
}
.Checkout_subscribeButton__oEXwa {
    background-color: #69bf4a;
    /* width: 400px; */
    text-align: center;
    padding: 16px;
    color: #fff;
    font-weight: bold;
    font-size: 34px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
    cursor: pointer;
    position: relative;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.Checkout_subscribeButton__oEXwa img {
    width: 16px;
    /* position: absolute;
    right: 20px; */
}
.Checkout_glow__Al2D4 {
    box-shadow: 0 0 30px #00ff00;
}

.Checkout_paymentDetails__Mt-Li {
    margin: 1em 3em;
}

.Checkout_paymentText__iFm0B {
    color: gray;
    font-size: 18px;
    line-height: 1.5;
    margin: 1em 0;
}

.Checkout_paymentText__iFm0B a {
    color: black;
}

.Checkout_banner__WUele {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: right;
    display: flex;
    align-items: end;
    position: relative;
    z-index: -1;
    height: 350px;
}
.Checkout_bannerText__6w470 {
    padding: 0 0 0 5%;
}
.Checkout_bannerSubtitle__91Ozi {
    font-size: 26px;
    font-weight: 700;
}
.Checkout_bannerTitle__38--V {
    font-size: 100px;
    font-family: 'Cocon Bold', sans-serif;
    padding-bottom: 10px;
}
.Checkout_dollar__VXR\\+c {
    font-size: 0.65em;
    position: relative;
    top: -0.5em;
}
.Checkout_lineItem__KysyX {
    display: flex;
    justify-content: space-between;
    font-size: 32px;
    font-weight: 700;
    margin: 0.5em 0;
}
.Checkout_total__CgZEH {
    font-size: 32px;
    font-family: 'Cocon Bold', sans-serif;
    font-weight: 800;
}
.Checkout_nextPayment__kTtVt {
    display: flex;
    flex-direction: column;
    margin-top: 2em;
}
.Checkout_fieldError__d0SMw {
    color: red;
    font-size: 1.25em;
    font-weight: 700;
    text-align: center;
}

@media screen and (max-width: 1561px) {
    .Checkout_paymentDetails__Mt-Li h3 {
        font-size: 32px;
    }
}
@media screen and (max-width: 1313px) {
    .Checkout_paymentDetails__Mt-Li h3 {
        font-size: 28px;
    }
}
@media screen and (max-width: 1220px) {
    .Checkout_banner__WUele {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        height: 250px;
        justify-content: center;
    }
    .Checkout_paymentDetails__Mt-Li h3 {
        margin-top: 1em;
        font-size: 40px;
    }
    .Checkout_leftSection__zfneh {
        width: 80%;
    }
    .Checkout_rightSection__tXaO\\+ {
        width: 98%;
    }
    .Checkout_titleImage__bf1\\+M {
        height: 120px;
        padding: 20px 40px;
    }
    .Checkout_titlePlan__11n5k {
        font-size: 48px;
    }
}
@media screen and (max-width: 1035px) {
    .Checkout_banner__WUele {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        height: 220px;
    }
    .Checkout_bannerTitle__38--V {
        font-size: 72px;
    }
    .Checkout_leftSection__zfneh {
        width: 90%;
    }
}
@media screen and (max-width: 836px) {
    .Checkout_leftSection__zfneh {
        width: 98%;
    }
    .Checkout_paymentDetails__Mt-Li {
        margin: 0 auto;
    }
}
@media screen and (max-width: 768px) {
    .Checkout_banner__WUele {
        justify-content: center;
        height: 200px;
    }
    .Checkout_titlePlan__11n5k {
        font-size: 40px;
    }
    .Checkout_selectButton__Zz46K {
        margin-top: 1.5em;
        width: 100%;
        display: flex;
        justify-content: center;
    }
}
@media screen and (max-width: 716px) {
    .Checkout_paymentDetails__Mt-Li h3 {
        margin-top: 1em;
        font-size: 28px;
    }
}
@media screen and (max-width: 638px) {
    .Checkout_headerRule__KJJty {
        height: 7px;
        bottom: -3px;
    }
    .Checkout_banner__WUele {
        height: 150px;
    }
    .Checkout_bannerTitle__38--V {
        font-size: 48px;
    }
    .Checkout_bannerSubtitle__91Ozi {
        font-size: 22px;
    }
    .Checkout_bannerText__6w470 {
        text-align: center;
    }
   /* .titlePlan {
        font-size: 28px;
    }
    .titlePlan p {
        font-size: 24px;
    } */
    .Checkout_planSubtext__lUdql {
        font-size: 24px;
    }
    .Checkout_planContainer__\\+DRrS {
        padding: 10px 10px;
    }
}
@media screen and (max-width: 512px) {
    .Checkout_bannerTitle__38--V {
        font-size: 32px;
    }
    .Checkout_bannerSubtitle__91Ozi {
        font-size: 18px;
    }
    .Checkout_optInSection__hP38j {
        margin: 0.5em 1em;
    }
    .Checkout_optInLabel__PjAoJ {
        font-size: 12px;
        padding-left: 0.5em;
    }
    .Checkout_titleImage__bf1\\+M {    
        height: 100px;
        padding: 10px 30px;
        /* border-top-left-radius: 2.8em; */
    }
    .Checkout_titlePlan__11n5k {
        font-size: 32px;
    }
    .Checkout_titlePlan__11n5k p {
        font-size: 22px;
    }
    .Checkout_titleDose__Pvb9f {
        font-size: 16px;
    }
    .Checkout_selectButton__Zz46K select {
        font-size: 20px;
        height: 48px;
    }
    .Checkout_planSubtext__lUdql {
        font-size: 18px;
    }
    .Checkout_secureDetails__n3iFU, .Checkout_lineItem__KysyX {
        margin-top: 1em;
        font-size: 24px;
    }
    .Checkout_cardTitle__BiVVj {
        font-size: 24px;
    }
    .Checkout_securePayment__V5ut3 p {
        font-size: 14px;
    }
    .Checkout_cardBox__qnylL, .Checkout_field__4kVlV, .Checkout_fieldError__d0SMw, .Checkout_phoneContainer__1ptV6 div, .Checkout_phonePart__-kgJP, .Checkout_emailContainer__kqdiD div, .Checkout_emailContainer__kqdiD input, .Checkout_city__rXsCS {
        font-size: 18px;
    }
    .Checkout_field__4kVlV::placeholder, .Checkout_phonePart__-kgJP::placeholder, .Checkout_city__rXsCS::placeholder, .Checkout_emailContainer__kqdiD input::placeholder {
        font-size: 18px;
    }
    .Checkout_emailContainer__kqdiD div {
        width: 40%;
    }
    .Checkout_lineItem__KysyX {
        font-size: 20px;
    }
    .Checkout_free__V-HB7, .Checkout_total__CgZEH {
        font-size: 28px;
    }
    .Checkout_subscribeButton__oEXwa {
        /* width: 350px; */
        font-size: 28px;
    }
    .Checkout_paymentText__iFm0B {
        font-size: 14px;
    }
    .Checkout_planPrice__gyrRJ {
        font-size: 32px;    
    }
}
@media screen and (max-width: 414px) {
    .Checkout_selectButton__Zz46K select {
        font-size: 18px;
    }
    /* .titlePlan {
        font-size: 22px;
    } */
    .Checkout_paymentDetails__Mt-Li h3 {
        margin-top: 1em;
        font-size: 22px;
    }
    .Checkout_securePayment__V5ut3 p {
        color: #69bf4a;
        font-size: 16px;
        font-weight: 600;
    }
    .Checkout_cardTitle__BiVVj {
        font-size: 22px;
    }
    .Checkout_planShipping__\\+O0KF {
        font-size: 22px;
    }
    .Checkout_planSubtext__lUdql {
        font-size: 16px;
    }
    .Checkout_emailContainer__kqdiD div {
        margin: 0.5em;
    }
    .Checkout_paymentText__iFm0B, .Checkout_lineItem__KysyX {
        font-size: 16px;
    }
    .Checkout_planFree__XEuoc, .Checkout_total__CgZEH {
        font-size: 24px;
    }
    .Checkout_secureDetails__n3iFU {
        font-size: 24px;
    }
    .Checkout_subscribeButton__oEXwa {
        /* width: 350px; */
        font-size: 24px;
    }
}
@media screen and (max-width: 375px) {
    .Checkout_banner__WUele {
        height: 140px;
    }
    .Checkout_planContainer__\\+DRrS {
        padding: 0px 0px;
    }
    .Checkout_titlePlan__11n5k {
        font-size: 22px;
        /* padding: 0.25em 0; */
    }
    .Checkout_titlePlan__11n5k p {
        font-size: 12px;
    }
    .Checkout_titleDose__Pvb9f {
        font-size: 12px;
    }
    .Checkout_titleImage__bf1\\+M {
        height: 60px;
        /* border-top-left-radius: 3em;
        border-bottom-right-radius: 3em; */
    }
    .Checkout_selectButton__Zz46K select {
        font-size: 14px;
    }
    .Checkout_differentArrow__27GL5 {
        right: 5px;
        width: 20px;
    }
    .Checkout_planSubtext__lUdql {
        font-size: 14px;
        margin-top: 0;
    }
    .Checkout_planFree__XEuoc {
        font-size: 20px;
    }
    .Checkout_cardTitle__BiVVj {
        font-size: 18px;
    }
    .Checkout_cardBox__qnylL, .Checkout_field__4kVlV {
        font-size: 16px;
    }
    .Checkout_field__4kVlV::placeholder, .Checkout_phonePart__-kgJP::placeholder, .Checkout_city__rXsCS::placeholder, .Checkout_emailContainer__kqdiD input::placeholder {
        font-size: 16px;
    }
    .Checkout_city__rXsCS {
        margin: 1em 0.5em;
    }
    .Checkout_phonePart__-kgJP {
        font-size: 16px;
        width: 25%;
    }
    .Checkout_planShipping__\\+O0KF {
        font-size: 16px;
    }
    .Checkout_planPrice__gyrRJ {
        font-size: 28px;
    }
    .Checkout_emailContainer__kqdiD div, .Checkout_phoneContainer__1ptV6 div {
        font-size: 16px;
        margin: 1em 0;
    }
    .Checkout_emailContainer__kqdiD input {
        font-size: 16px;
    }
    .Checkout_paymentText__iFm0B {
        font-size: 14px;
    }
    .Checkout_planPeriod__rxG9e {
        font-size: 12px;
    }
    .Checkout_secureDetails__n3iFU {
        font-size: 18px;
    }
    .Checkout_securePayment__V5ut3 p {
        font-size: 12px;
    }
    .Checkout_subscribeButton__oEXwa {
        font-size: 20px;
    }
}
@media screen and (max-width: 308px){
    .Checkout_titlePlan__11n5k {
        font-size: 18px;
        /* border-top-right-radius: 1em; */
    }
    .Checkout_titleImage__bf1\\+M {
        height: 50px;
        /* border-top-left-radius: 3em; */
        /* border-bottom-right-radius: 2em; */
    }
    .Checkout_titleDose__Pvb9f {
        font-size: 10px;
    }
    .Checkout_planSubtext__lUdql {
        font-size: 12px;
    }
    .Checkout_phoneContainer__1ptV6 div, .Checkout_emailContainer__kqdiD div {
        padding-left: 1em;
    }
    .Checkout_securePayment__V5ut3 {
        gap: 5px;
    }
    .Checkout_subscribeButton__oEXwa {
        padding: 10px;
        font-size: 20px;
    }
    .Checkout_planPrice__gyrRJ {
        font-size: 24px;
    }

}
@media screen and (max-width: 250px) {
    .Checkout_titleImage__bf1\\+M {
        display: none;
    }
    .Checkout_titlePlan__11n5k {
        margin-left: 0.5em;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Checkout/Checkout.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,4EAA4E;AAChF;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;;;;;;;GAOG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,QAAQ;IACR,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;AACf;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,2BAA2B;IAC3B,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;AAC7C;AACA;IACI,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,4EAA4E;AAChF;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,kBAAkB;AACtB;;;;AAIA;IACI,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,4EAA4E;IAC5E,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,4EAA4E;IAC5E,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,eAAe;IACf,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,eAAe;IACf,OAAO;IACP,SAAS;IACT,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,4EAA4E;AAChF;AACA;IACI,WAAW;IACX;kBACc;AAClB;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yDAAuD;IACvD,sBAAsB;IACtB,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,yDAAyD;QACzD,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,yDAAyD;QACzD,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,uBAAuB;QACvB,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,WAAW;QACX,aAAa;QACb,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;GACD;;;;;OAKI;IACH;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,mCAAmC;IACvC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;;OAEG;IACH;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ;0CACkC;IACtC;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;QACf,kCAAkC;IACtC;IACA;QACI,YAAY;QACZ,iCAAiC;QACjC,qCAAqC;IACzC;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,QAAQ;IACZ;IACA;QACI,aAAa;QACb,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;AAEJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".checkout {\n    display: flex;\n    flex-direction: row;\n    overflow-wrap: none;\n    width: 94%;\n    margin: 0 auto;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.leftSection {\n    margin-top: 1em;\n    color: #000;\n    background-color: transparent;\n    width: 620px;\n}\n\n.planBox {\n    border-radius: 32px;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n.semaBorder {\n    border: 1px solid #69bf4a;\n}\n.tirzBorder {\n    border: 1px solid #21cec9;\n}\n.semaSides {\n    border-left: 10px solid #69bf4a;\n    border-right: 10px solid #69bf4a;\n}\n.tirzSides {\n    border-left: 10px solid #21cec9;\n    border-right: 10px solid #21cec9;\n}\n.semaBackground {\n    background-color: #69bf4a;\n}\n.tirzBackground {\n    background-color: #21cec9;\n}\n/* .semaImg {\n    border-bottom: 10px solid #69bf4a;\n    border-right: 10px solid #69bf4a;\n}\n.tirzImg {\n    border-bottom: 10px solid #21cec9;\n    border-right: 10px solid #21cec9;\n} */\n\n.title {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1em;\n    border-top-left-radius: 2em;\n    border-top-right-radius: 2em;\n    width: 100%;\n}\n.titleImage {    \n    height: 150px;\n    padding: 30px 60px;\n    background-color: white;\n    margin-left: 0.5em;\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n    border-top-left-radius: 2em;\n    border-bottom-right-radius: 2em;\n}\n.titleName {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    line-height: 1.1;\n}\n.titlePlan {\n    /* border-top-right-radius: 1em; */\n    font-family: 'Aktive Grotesk', sans-serif;\n    font-size: 40px;\n    font-weight: 800;\n    color: #fff;\n    /* padding: 15px 30px; */\n    padding: 0.25em 0;\n    /* margin-right: 1em; */\n    text-align: center;\n}\n.titlePlan p {\n    margin: 0;\n    font-size: 32px;\n    font-weight: 500;\n}\n.titleDose {\n    margin-top: 0.25em;\n    margin-bottom: 0.25em;\n    /* margin-left: 1em; */\n    font-size: 24px;\n    font-weight: 700;\n    color: white;\n    width: 100%;\n    text-align: center;\n}\n.planContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: center;\n    padding: 10px 60px;\n}\n.planPrice {\n    width: 48%;\n    padding: 10px 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Cocon Bold', sans-serif;\n    font-weight: 800;\n    font-size: 48px;\n}\n.planPeriod {\n    font-size: 20px;\n    font-weight: 500;\n    font-family: 'Aktiv Grotesk';\n    text-align: center;\n}\n.planShipping {\n    width: 48%;\n    padding: 10px 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Aktive Grotesk', sans-serif;\n    font-weight: 800;\n    font-size: 30px;\n}\n.planFree {\n    font-size: 36px;\n    color: #69bf4a;\n}\n.planSubtext {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    margin-top: 0.5em;\n    padding-bottom: 0.5em;\n    padding-left: 0.5em;\n    padding-right: 0.5em;\n    font-size: 28px;\n    color: gray;\n    font-weight: 700;\n}\n.differentArrow {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 25px;\n}\n.selectButton {\n    margin-top: 1em;\n    position: relative;\n}\n.selectButton select {\n    width: 100%;\n    padding: 10px;\n    font-weight: bold;\n    height: 64px;\n    font-size: 30px;\n    border-radius: 46px;\n    text-align: center;\n    border: 2px solid;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background: transparent;\n    background-image: none;\n}\n.headerRule {\n    height: 10px;\n    width: 90%;\n    margin-left: 90px;\n    margin-right: 90px;\n    background-color: #69bf4a;\n    position: absolute;\n    bottom: -5px;\n    border-radius: 999px;\n}\n.horizontalRule {\n    display: block;\n    width: 90%;\n    padding-left: 5%;\n    height: 5px;\n}\n.fieldRule {\n    width: 100%;\n    height: 5px;\n}\n.verticalRule {\n    height: 50px;\n    width: 5px;\n}\n.fieldSection {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n}\n.cardTitle {\n    margin-top: 0.5em;\n    font-size: 32px;\n    font-weight: 800;\n}\n.field {\n    margin: 1em 2em;\n    font-size: 26px;\n    font-weight: 700;\n    border: 0;\n    color: black;\n    text-align: center;\n    font-family: 'Aktive Grotesk', sans-serif;\n}\n.field::placeholder {\n    text-align: center;\n}\n\n\n.emailContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    font-size: 26px;\n    font-weight: 700;\n    margin: 0.5em;\n    align-items: center;\n    width: 96%;\n    border: 8px solid #69bf4a;\n    border-radius: 2em;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n.emailContainer div {\n    margin: 1em 0;\n    padding-left: 2em;\n    width: 40%;\n    box-sizing: border-box;\n    font-size: 26px;\n    font-weight: 700;\n    border: 0;\n    color: grey;\n}\n.emailContainer input {\n    width: 60%;\n    box-sizing: border-box;\n    font-size: 26px;\n    font-weight: 700;\n    border: 0;\n    color: black;\n    border-top-right-radius: 2em;\n    border-bottom-right-radius: 2em;\n}\n.emailContainer input::placeholder {\n    text-align: center;\n}\n\n\n\n.phoneContainer {\n    width: 96%;\n    border: 8px solid #69bf4a;\n    border-radius: 2em;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 26px;\n    font-weight: 700;\n    margin: 0.5em;\n}\n.phoneContainer div {\n    margin: 1em 0;\n    padding-left: 2em;\n    width: 35%;\n    box-sizing: border-box;\n    font-size: 26px;\n    font-weight: 700;\n    border: 0;\n    color: grey;\n}\n.phoneContainer span {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    width: 65%;\n}\n.phonePart {\n    color: black;\n    width: 30%;\n    font-size: 26px;\n    font-weight: 700;\n    border: 0;\n    border-top-right-radius: 2em;\n    border-bottom-right-radius: 2em;\n}\n.phonePart::placeholder {\n    text-align: center;\n}\n.optInSection {\n    display: flex;\n    align-items: flex-start;\n    margin: 1em 2em;\n}\n.optInSection input {\n    transform: scale(1.5);\n}\n.optInLabel {\n    color: gray;\n    font-size: 16px;\n    padding-left: 1em;\n}\n\n.cardBox {\n    width: 96%;\n    border: 8px solid #69bf4a;\n    border-radius: 2em;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    font-size: 26px;\n    font-weight: 700;\n    margin: 0.5em;\n}\n.billingAddress {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n.city {\n    width: 40%;\n    margin: 1em 2em;\n    font-family: 'Aktive Grotesk', sans-serif;\n    font-size: 26px;\n    font-weight: 700;\n    border: 0;\n    text-align: center;\n    color: black;\n}\n.stateFieldPlaceholder {\n    text-align: center;\n    color: grey;\n}\n.stateField {\n    text-align: center;\n    color: black;\n}\n.statePopup {\n    position: fixed;\n    top: 0%;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: white;\n    width: 100%;\n    max-height: 100%;\n    overflow-y: auto;\n    border: 1px solid #ccc;\n    z-index: 999;\n    text-align: center;\n    color: black;\n}\n.stateOption:hover, .stateOption:active, .stateOption:focus {\n    background-color: #69bf4a;\n    color: white;\n    font-weight: bold;\n}\n\n.free {\n    color: #69bf4a;\n    font-family: 'Cocon Bold', sans-serif;\n    font-size: 32px;\n}\n\n.rightSection {\n    width: 45%;\n    font-family: 'Aktive Grotesk', sans-serif;\n}\n\n.paymentDetails h3 {\n    font-size: 40px;\n    font-weight: 800;\n    margin: 0px 20px;\n    text-align: center;\n}\n\n.secureDetails {\n    margin-top: 0.5em;\n    text-align: center;\n    font-size: 36px;\n    font-weight: 800;\n}\n\n.securePayment {\n    display: flex;\n    justify-content: center;\n    align-items: baseline;\n    gap: 11px;\n}\n\n.securePayment p {\n    color: #69bf4a;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n\n.subscribeButtonBox {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    text-align: center;\n    margin-top: 2em;\n}\n.subscribeButton {\n    background-color: #69bf4a;\n    /* width: 400px; */\n    text-align: center;\n    padding: 16px;\n    color: #fff;\n    font-weight: bold;\n    font-size: 34px;\n    border-radius: 999px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    justify-content: center;\n    cursor: pointer;\n    position: relative;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n.subscribeButton img {\n    width: 16px;\n    /* position: absolute;\n    right: 20px; */\n}\n.glow {\n    box-shadow: 0 0 30px #00ff00;\n}\n\n.paymentDetails {\n    margin: 1em 3em;\n}\n\n.paymentText {\n    color: gray;\n    font-size: 18px;\n    line-height: 1.5;\n    margin: 1em 0;\n}\n\n.paymentText a {\n    color: black;\n}\n\n.banner {\n    background-image: url(../../assets/checkout-banner.png);\n    background-size: cover;\n    background-position: right;\n    display: flex;\n    align-items: end;\n    position: relative;\n    z-index: -1;\n    height: 350px;\n}\n.bannerText {\n    padding: 0 0 0 5%;\n}\n.bannerSubtitle {\n    font-size: 26px;\n    font-weight: 700;\n}\n.bannerTitle {\n    font-size: 100px;\n    font-family: 'Cocon Bold', sans-serif;\n    padding-bottom: 10px;\n}\n.dollar {\n    font-size: 0.65em;\n    position: relative;\n    top: -0.5em;\n}\n.lineItem {\n    display: flex;\n    justify-content: space-between;\n    font-size: 32px;\n    font-weight: 700;\n    margin: 0.5em 0;\n}\n.total {\n    font-size: 32px;\n    font-family: 'Cocon Bold', sans-serif;\n    font-weight: 800;\n}\n.nextPayment {\n    display: flex;\n    flex-direction: column;\n    margin-top: 2em;\n}\n.fieldError {\n    color: red;\n    font-size: 1.25em;\n    font-weight: 700;\n    text-align: center;\n}\n\n@media screen and (max-width: 1561px) {\n    .paymentDetails h3 {\n        font-size: 32px;\n    }\n}\n@media screen and (max-width: 1313px) {\n    .paymentDetails h3 {\n        font-size: 28px;\n    }\n}\n@media screen and (max-width: 1220px) {\n    .banner {\n        background-image: url(../../assets/checkout-banner-2.png);\n        height: 250px;\n        justify-content: center;\n    }\n    .paymentDetails h3 {\n        margin-top: 1em;\n        font-size: 40px;\n    }\n    .leftSection {\n        width: 80%;\n    }\n    .rightSection {\n        width: 98%;\n    }\n    .titleImage {\n        height: 120px;\n        padding: 20px 40px;\n    }\n    .titlePlan {\n        font-size: 48px;\n    }\n}\n@media screen and (max-width: 1035px) {\n    .banner {\n        background-image: url(../../assets/checkout-banner-2.png);\n        height: 220px;\n    }\n    .bannerTitle {\n        font-size: 72px;\n    }\n    .leftSection {\n        width: 90%;\n    }\n}\n@media screen and (max-width: 836px) {\n    .leftSection {\n        width: 98%;\n    }\n    .paymentDetails {\n        margin: 0 auto;\n    }\n}\n@media screen and (max-width: 768px) {\n    .banner {\n        justify-content: center;\n        height: 200px;\n    }\n    .titlePlan {\n        font-size: 40px;\n    }\n    .selectButton {\n        margin-top: 1.5em;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    }\n}\n@media screen and (max-width: 716px) {\n    .paymentDetails h3 {\n        margin-top: 1em;\n        font-size: 28px;\n    }\n}\n@media screen and (max-width: 638px) {\n    .headerRule {\n        height: 7px;\n        bottom: -3px;\n    }\n    .banner {\n        height: 150px;\n    }\n    .bannerTitle {\n        font-size: 48px;\n    }\n    .bannerSubtitle {\n        font-size: 22px;\n    }\n    .bannerText {\n        text-align: center;\n    }\n   /* .titlePlan {\n        font-size: 28px;\n    }\n    .titlePlan p {\n        font-size: 24px;\n    } */\n    .planSubtext {\n        font-size: 24px;\n    }\n    .planContainer {\n        padding: 10px 10px;\n    }\n}\n@media screen and (max-width: 512px) {\n    .bannerTitle {\n        font-size: 32px;\n    }\n    .bannerSubtitle {\n        font-size: 18px;\n    }\n    .optInSection {\n        margin: 0.5em 1em;\n    }\n    .optInLabel {\n        font-size: 12px;\n        padding-left: 0.5em;\n    }\n    .titleImage {    \n        height: 100px;\n        padding: 10px 30px;\n        /* border-top-left-radius: 2.8em; */\n    }\n    .titlePlan {\n        font-size: 32px;\n    }\n    .titlePlan p {\n        font-size: 22px;\n    }\n    .titleDose {\n        font-size: 16px;\n    }\n    .selectButton select {\n        font-size: 20px;\n        height: 48px;\n    }\n    .planSubtext {\n        font-size: 18px;\n    }\n    .secureDetails, .lineItem {\n        margin-top: 1em;\n        font-size: 24px;\n    }\n    .cardTitle {\n        font-size: 24px;\n    }\n    .securePayment p {\n        font-size: 14px;\n    }\n    .cardBox, .field, .fieldError, .phoneContainer div, .phonePart, .emailContainer div, .emailContainer input, .city {\n        font-size: 18px;\n    }\n    .field::placeholder, .phonePart::placeholder, .city::placeholder, .emailContainer input::placeholder {\n        font-size: 18px;\n    }\n    .emailContainer div {\n        width: 40%;\n    }\n    .lineItem {\n        font-size: 20px;\n    }\n    .free, .total {\n        font-size: 28px;\n    }\n    .subscribeButton {\n        /* width: 350px; */\n        font-size: 28px;\n    }\n    .paymentText {\n        font-size: 14px;\n    }\n    .planPrice {\n        font-size: 32px;    \n    }\n}\n@media screen and (max-width: 414px) {\n    .selectButton select {\n        font-size: 18px;\n    }\n    /* .titlePlan {\n        font-size: 22px;\n    } */\n    .paymentDetails h3 {\n        margin-top: 1em;\n        font-size: 22px;\n    }\n    .securePayment p {\n        color: #69bf4a;\n        font-size: 16px;\n        font-weight: 600;\n    }\n    .cardTitle {\n        font-size: 22px;\n    }\n    .planShipping {\n        font-size: 22px;\n    }\n    .planSubtext {\n        font-size: 16px;\n    }\n    .emailContainer div {\n        margin: 0.5em;\n    }\n    .paymentText, .lineItem {\n        font-size: 16px;\n    }\n    .planFree, .total {\n        font-size: 24px;\n    }\n    .secureDetails {\n        font-size: 24px;\n    }\n    .subscribeButton {\n        /* width: 350px; */\n        font-size: 24px;\n    }\n}\n@media screen and (max-width: 375px) {\n    .banner {\n        height: 140px;\n    }\n    .planContainer {\n        padding: 0px 0px;\n    }\n    .titlePlan {\n        font-size: 22px;\n        /* padding: 0.25em 0; */\n    }\n    .titlePlan p {\n        font-size: 12px;\n    }\n    .titleDose {\n        font-size: 12px;\n    }\n    .titleImage {\n        height: 60px;\n        /* border-top-left-radius: 3em;\n        border-bottom-right-radius: 3em; */\n    }\n    .selectButton select {\n        font-size: 14px;\n    }\n    .differentArrow {\n        right: 5px;\n        width: 20px;\n    }\n    .planSubtext {\n        font-size: 14px;\n        margin-top: 0;\n    }\n    .planFree {\n        font-size: 20px;\n    }\n    .cardTitle {\n        font-size: 18px;\n    }\n    .cardBox, .field {\n        font-size: 16px;\n    }\n    .field::placeholder, .phonePart::placeholder, .city::placeholder, .emailContainer input::placeholder {\n        font-size: 16px;\n    }\n    .city {\n        margin: 1em 0.5em;\n    }\n    .phonePart {\n        font-size: 16px;\n        width: 25%;\n    }\n    .planShipping {\n        font-size: 16px;\n    }\n    .planPrice {\n        font-size: 28px;\n    }\n    .emailContainer div, .phoneContainer div {\n        font-size: 16px;\n        margin: 1em 0;\n    }\n    .emailContainer input {\n        font-size: 16px;\n    }\n    .paymentText {\n        font-size: 14px;\n    }\n    .planPeriod {\n        font-size: 12px;\n    }\n    .secureDetails {\n        font-size: 18px;\n    }\n    .securePayment p {\n        font-size: 12px;\n    }\n    .subscribeButton {\n        font-size: 20px;\n    }\n}\n@media screen and (max-width: 308px){\n    .titlePlan {\n        font-size: 18px;\n        /* border-top-right-radius: 1em; */\n    }\n    .titleImage {\n        height: 50px;\n        /* border-top-left-radius: 3em; */\n        /* border-bottom-right-radius: 2em; */\n    }\n    .titleDose {\n        font-size: 10px;\n    }\n    .planSubtext {\n        font-size: 12px;\n    }\n    .phoneContainer div, .emailContainer div {\n        padding-left: 1em;\n    }\n    .securePayment {\n        gap: 5px;\n    }\n    .subscribeButton {\n        padding: 10px;\n        font-size: 20px;\n    }\n    .planPrice {\n        font-size: 24px;\n    }\n\n}\n@media screen and (max-width: 250px) {\n    .titleImage {\n        display: none;\n    }\n    .titlePlan {\n        margin-left: 0.5em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkout": `Checkout_checkout__0l1eZ`,
	"leftSection": `Checkout_leftSection__zfneh`,
	"planBox": `Checkout_planBox__Ue+Kz`,
	"semaBorder": `Checkout_semaBorder__ijxBV`,
	"tirzBorder": `Checkout_tirzBorder__pbDbJ`,
	"semaSides": `Checkout_semaSides__jvKn0`,
	"tirzSides": `Checkout_tirzSides__OdVn+`,
	"semaBackground": `Checkout_semaBackground__KQh-d`,
	"tirzBackground": `Checkout_tirzBackground__3Spx0`,
	"title": `Checkout_title__PIroP`,
	"titleImage": `Checkout_titleImage__bf1+M`,
	"titleName": `Checkout_titleName__V7zMV`,
	"titlePlan": `Checkout_titlePlan__11n5k`,
	"titleDose": `Checkout_titleDose__Pvb9f`,
	"planContainer": `Checkout_planContainer__+DRrS`,
	"planPrice": `Checkout_planPrice__gyrRJ`,
	"planPeriod": `Checkout_planPeriod__rxG9e`,
	"planShipping": `Checkout_planShipping__+O0KF`,
	"planFree": `Checkout_planFree__XEuoc`,
	"planSubtext": `Checkout_planSubtext__lUdql`,
	"differentArrow": `Checkout_differentArrow__27GL5`,
	"selectButton": `Checkout_selectButton__Zz46K`,
	"headerRule": `Checkout_headerRule__KJJty`,
	"horizontalRule": `Checkout_horizontalRule__n93pZ`,
	"fieldRule": `Checkout_fieldRule__DFIVv`,
	"verticalRule": `Checkout_verticalRule__Vl1fB`,
	"fieldSection": `Checkout_fieldSection__eJ7V4`,
	"cardTitle": `Checkout_cardTitle__BiVVj`,
	"field": `Checkout_field__4kVlV`,
	"emailContainer": `Checkout_emailContainer__kqdiD`,
	"phoneContainer": `Checkout_phoneContainer__1ptV6`,
	"phonePart": `Checkout_phonePart__-kgJP`,
	"optInSection": `Checkout_optInSection__hP38j`,
	"optInLabel": `Checkout_optInLabel__PjAoJ`,
	"cardBox": `Checkout_cardBox__qnylL`,
	"billingAddress": `Checkout_billingAddress__6gDGd`,
	"city": `Checkout_city__rXsCS`,
	"stateFieldPlaceholder": `Checkout_stateFieldPlaceholder__2bVEc`,
	"stateField": `Checkout_stateField__Gaxa-`,
	"statePopup": `Checkout_statePopup__IpCml`,
	"stateOption": `Checkout_stateOption__Ap2Y+`,
	"free": `Checkout_free__V-HB7`,
	"rightSection": `Checkout_rightSection__tXaO+`,
	"paymentDetails": `Checkout_paymentDetails__Mt-Li`,
	"secureDetails": `Checkout_secureDetails__n3iFU`,
	"securePayment": `Checkout_securePayment__V5ut3`,
	"subscribeButtonBox": `Checkout_subscribeButtonBox__ZCFvg`,
	"subscribeButton": `Checkout_subscribeButton__oEXwa`,
	"glow": `Checkout_glow__Al2D4`,
	"paymentText": `Checkout_paymentText__iFm0B`,
	"banner": `Checkout_banner__WUele`,
	"bannerText": `Checkout_bannerText__6w470`,
	"bannerSubtitle": `Checkout_bannerSubtitle__91Ozi`,
	"bannerTitle": `Checkout_bannerTitle__38--V`,
	"dollar": `Checkout_dollar__VXR+c`,
	"lineItem": `Checkout_lineItem__KysyX`,
	"total": `Checkout_total__CgZEH`,
	"nextPayment": `Checkout_nextPayment__kTtVt`,
	"fieldError": `Checkout_fieldError__d0SMw`
};
export default ___CSS_LOADER_EXPORT___;
